/* tslint:disable:no-var-requires */
import bugsnag from '@bugsnag/js'
import getConfig from 'next/config'
import React from 'react'

const bugsnagReact = require('@bugsnag/plugin-react')
let bugsnagExpress
if (!process.browser) {
  bugsnagExpress = require('@bugsnag/plugin-express')
}

export const createBugsnagClient = () => {
  const { serverRuntimeConfig, publicRuntimeConfig } = getConfig()

  const apiKey = serverRuntimeConfig.bugsnagAPIKey || publicRuntimeConfig.bugsnagAPIKey

  const client = bugsnag({
    apiKey,
    appVersion: publicRuntimeConfig.appVersion,
    enabledReleaseStages: ['staging', 'production'],
    releaseStage: publicRuntimeConfig.releaseEnv,
  })

  client.use(bugsnagReact, React)
  if (typeof window === 'undefined') {
    client.use(bugsnagExpress)
  }

  return client
}

// Use a singleton to prevent instantiating multiple clients server side.
let bugsnagClient
const getBugsnagClient = () => {
  if (bugsnagClient) {
    return bugsnagClient
  }
  bugsnagClient = createBugsnagClient()
  return bugsnagClient
}

export default getBugsnagClient
